import * as React from "react";

type LocalStorageHook<T> = [T, (value: T) => void];

export const useLocalStorage = <T>(key: string, initialValue: T): LocalStorageHook<T> => {
    const [storedValue, setStoredValue] = React.useState((): T => {
        try {
            const item = window.localStorage.getItem(key);
            // eslint-disable-next-line @typescript-eslint/no-unsafe-return
            return item ? JSON.parse(item) : initialValue;
        } catch (error) {
            // eslint-disable-next-line no-console
            console.log(error);
            return initialValue;
        }
    });

    const setValue = (value: T | ((prev: T) => T)) => {
        try {
            const valueToStore = value instanceof Function ? value(storedValue) : value;
            setStoredValue(valueToStore);
            window.localStorage.setItem(key, JSON.stringify(valueToStore));
        } catch (error) {
            // eslint-disable-next-line no-console
            console.log(error);
        }
    };

    return [storedValue, setValue];
};
